import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from './../../APP/COMPONENTS/Loader';
import ProductionInterface from '../COMPONENTS/ProductionInterface/index.js';

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER,
        PRINTER_IP: state.PRINTER_IP
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class Qr extends Component {
    constructor(props) {
        super(props);
        this.state = {
            USER: this.props.USER,
            LOADED: false,
            PRODUCTS: false,
            GROUPS: false,
            FILTER: {
                TITLE: null,
                GROUP: null,
                ARCHIVE: 0,
                DISABLED: 0,
                OUTOFSTOCK: 0
            },
            PRINT_PRODUCT: false
        }
    }

    componentDidMount = () => {
        this.fetchProducts();
    }


    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.USER !== prevProps.USER) {
            this.setState({ USER: this.props.USER });
        }
    }

    fetchProducts = async () => {
        try {
            let data = await Request({}, 'products/products-groups');
            if (data !== false) {
                this.setState({ PRODUCTS: this.prepareProductsArray(data.products), GROUPS: data.categories, LOADED: true });
            } else {
                this.setState({ LOADED: true });
            }
        } catch (error) {
        }
    }

    prepareProductsArray = (products) => {
        const readyProducts = [];

        for (let i = 0; i < products.length; i++) {
            let product = products[i];
            product.start = null
            product.end = null
            readyProducts.push(product)
        }

        return readyProducts
    }

    renderProducts = () => {
        if (this.state.LOADED) {
            if (this.state.PRODUCTS) {
                let PRODUCTS = this.filterProducts();
                let TBODY = this.renderProductsRows(PRODUCTS);
                let HEADER = this.renderProductsTableHeader();

                return (
                    <div className="table_holder">
                        <table id="products_table" className="products_table" cellPadding="0" cellSpacing="0">
                            { HEADER }
                            { TBODY }
                        </table>
                        <table id="products_table_saveable" className="products_table_saveable" cellPadding="0" cellSpacing="0">
                            { this.renderProductsTableHeader(true) }
                            { this.renderProductsRows(PRODUCTS, true) }
                        </table>
                    </div>
                );
            } else {
                return <div className="table_holder"><h3>Мы не нашли ваших товаров в базе</h3></div>;
            }
        } else {
            return <div className="table_holder"><Loader /><div className="loader_content">Собираем статистику по товарам ...</div></div>
        }
    }

    renderImage = (PRODUCT) => {
        let SRC = PRODUCT.thumb;
        if ((typeof SRC !== "undefined") && (SRC !== "")) {
            return (
                <img
                    className="product_image"
                    src={ SRC }
                />
            );
        }

        return false;
    }

    getProductGroups = (PRODUCT) => {
        let GROUPS = [];
        for (let i = 0; i < PRODUCT.categories.length; i++) {
            let GROUP = false;

            for (let j = 0; j < this.state.GROUPS.length; j++) {
                if (this.state.GROUPS[j].id.toString() == PRODUCT.categories[i].toString()) {
                    GROUP = this.state.GROUPS[j].name;
                }
            }

            if (GROUP) {
                GROUPS.push(<span key={ i } className="group_title">{ GROUP }</span>);
            }
        }

        return GROUPS;
    }

    renderProductStatuses = (PRODUCT) => {
        let STATUSES = [];
        if (parseInt(PRODUCT.archive) == 1) {
            STATUSES.push(
                <span key="archive" className="archive_label">Архив</span>
            );
        }
        if (parseInt(PRODUCT.active) == 0) {
            STATUSES.push(
                <span key="disabled" className="disabled_label">Отключен</span>
            );
        }

        if (STATUSES.length) {
            return (
                <div className="product_title_labels">
                    { STATUSES }
                </div>
            );
        }

        return null;
    }

    printSticker = (product) => {
        console.log(product)
    }

    addAmountClassToCell = (AMOUNT) => {
        if (parseInt(AMOUNT) == 0) {
            return ' out_of_stock_cell';
        }

        return null;
    }

    renderProductCreateInput = (PRODUCT) => {
        return (
            <input
                type="datetime-local"
                onChange={ (text) => this.setStart(text.target.value, PRODUCT) }
            />
        )
    }

    renderProductEndInput = (PRODUCT) => {
        return (
            <input
                type="datetime-local"
                onChange={ (text) => this.setEnd(text.target.value, PRODUCT) }
            />
        )
    }

    setStart = (value, PRODUCT) => {
        const readyProducts = [];

        for (let i = 0; i < this.state.PRODUCTS.length; i++) {
            let product = this.state.PRODUCTS[i];
            if (product.id == PRODUCT.id) {
                product.start = value
            }
            readyProducts.push(product)
        }

        this.setState({ PRODUCTS: readyProducts })
    }

    setEnd = (value, PRODUCT) => {
        const readyProducts = [];

        for (let i = 0; i < this.state.PRODUCTS.length; i++) {
            let product = this.state.PRODUCTS[i];
            if (product.id == PRODUCT.id) {
                product.end = value
            }
            readyProducts.push(product)
        }

        this.setState({ PRODUCTS: readyProducts })
    }

    printQr = (PRODUCT) => {
        let barcode = ''
        if (PRODUCT.barcodes.length) {
            barcode = PRODUCT.barcodes[0]
        }

        window.open('/print_qr?bc=' + barcode + '&start=' + PRODUCT.start + '&end=' + PRODUCT.end, '_blank').focus()
    }

    renderProductsRows = (PRODUCTS, SAVEABLE) => {
        let ROWS = [];
        for (let i = 0; i < PRODUCTS.length; i++) {
            let PRODUCT = PRODUCTS[i];

            ROWS.push(
                <tr key={ i }>
                    { (typeof SAVEABLE !== "undefined") ? null : (<td className="cell-center">{ this.renderImage(PRODUCT) }</td>) }
                    <td><span className="product_title">{ PRODUCT.name }{ this.renderProductStatuses(PRODUCT) }</span></td>
                    <td>{ this.getProductGroups(PRODUCT) }</td>
                    <td className="cell-center">{ this.renderProductCreateInput(PRODUCT) }</td>
                    <td className="cell-center">{ this.renderProductEndInput(PRODUCT) }</td>
                    <td className="cell-center">
                        { PRODUCT.start !== null && PRODUCT.end !== null ? <a onClick={ () => this.printQr(PRODUCT) } className="qr_enabled">распечатать qr</a> : <a className="qr_disabled">распечатать qr</a> }
                        <br />
                        <br />
                        { this.props.PRINTER_IP && this.props.PRINTER_IP.length ? <a className="qr_enabled" onClick={ () => this.setState({ PRINT_PRODUCT: PRODUCT }) }>распечатать этикетку</a> : <a className="qr_disabled">распечатать этикетку</a> }
                    </td>
                </tr>
            );
        }

        return (
            <tbody>
                { ROWS }
            </tbody>
        );
    }

    renderProductsTableHeader = (SAVEABLE) => {
        return (
            <thead>
                <tr>
                    { (typeof SAVEABLE !== "undefined") ? null : (<th>фото</th>) }
                    <th>наименование</th>
                    <th>категории</th>
                    <th>время производства</th>
                    <th>срок годности</th>
                    <th></th>
                </tr>
            </thead>
        );
    }

    renderFiter = () => {
        return (
            <div className="filter_head">
                <h1>QR на товары</h1>
                { this.renderSearchInput() }
                { this.renderGroupSelect() }
                { this.renderCheckboxes() }
            </div>
        );
    }

    appendFilter = (data, type) => {
        let FILTER = this.state.FILTER;
        if (type == 'GROUP') {
            let value = data.target.value;
            if (value == 0) {
                value = null;
            }
            FILTER[type] = value;
        } else if (type == 'DISABLED') {
            FILTER[type] = !this.state.FILTER.DISABLED;
        } else if (type == 'ARCHIVE') {
            FILTER[type] = !this.state.FILTER.ARCHIVE;
        } else if (type == 'OUTOFSTOCK') {
            FILTER[type] = !this.state.FILTER.OUTOFSTOCK;
        } else {
            FILTER[type] = data.target.value;
        }

        this.setState({ FILTER: FILTER });
    }

    filterProducts = () => {
        let FILTER_RESULTS = [];
        let STRING = null;
        let COMPARE = null;

        for (let i = 0; i < this.state.PRODUCTS.length; i++) {
            let PRODUCT = this.state.PRODUCTS[i];
            let FOUND = true;

            if (FOUND) {
                let ARCHIVE_DEFAULT = 0;
                if (this.state.FILTER.ARCHIVE) {
                    ARCHIVE_DEFAULT = 1;
                }

                if (parseInt(PRODUCT.archive) == ARCHIVE_DEFAULT) {
                    FOUND = true;
                } else {
                    FOUND = false;
                }
            }

            if (FOUND) {
                if (this.state.FILTER.DISABLED == 1) {
                    if (parseInt(PRODUCT.active) == 0) {
                        FOUND = true;
                    } else {
                        FOUND = false;
                    }
                } else {
                    if (parseInt(PRODUCT.active) == 0) {
                        FOUND = false;
                    }
                }
            }

            if (FOUND) {
                if (this.state.FILTER.OUTOFSTOCK == 1) {
                    if (!PRODUCT.amounts || !PRODUCT.amounts[1]) {
                        FOUND = true;
                    } else {
                        if (parseInt(PRODUCT.amounts[1].amount) <= 0) {
                            FOUND = true;
                        } else {
                            FOUND = false;
                        }
                    }
                }
            }

            if (FOUND) {
                if (this.state.FILTER.GROUP !== null) {
                    COMPARE = this.state.FILTER.GROUP.toString();

                    if (PRODUCT.groups.indexOf(COMPARE) == -1) {
                        FOUND = false;
                    } else {
                        FOUND = true;
                    }
                }
            }

            if (FOUND) {
                if (this.state.FILTER.TITLE !== null) {
                    STRING = PRODUCT.title.toUpperCase();
                    COMPARE = this.state.FILTER.TITLE.toUpperCase();

                    if (STRING.indexOf(COMPARE) !== -1) {
                        FOUND = true;
                    } else {
                        FOUND = false;
                    }
                }
            }

            if (FOUND) {
                FILTER_RESULTS.push(PRODUCT);
            }
        }
        return FILTER_RESULTS;

    }

    renderSearchInput = () => {
        if (this.state.LOADED) {
            return (
                <div className="filter_inputs_holder">
                    <div className="filter_element">
                        <input
                            type="text"
                            placehodler="Поиск"
                            value={ this.state.FILTER.TITLE }
                            onChange={ (text) => this.appendFilter(text, 'TITLE') }
                        />
                        <img className="search_icon" src="/system_images/search_icon.png" />
                    </div>
                </div>
            );
        }
    }

    renderCheckboxes = () => {
        if (this.state.LOADED) {
            return (
                <div className="filter_inputs_holder">
                    <input
                        type="checkbox"
                        id="outofstock"
                        name="outofstock"
                        value="1"
                        checked={ this.state.FILTER.OUTOFSTOCK }
                        onChange={ (input) => { this.appendFilter(input, 'OUTOFSTOCK') } }
                    />
                    <label htmlFor="outofstock">
                        <span></span>
                        Нет в наличии
                    </label>

                    <input
                        type="checkbox"
                        id="disabled"
                        name="disabled"
                        value="1"
                        checked={ this.state.FILTER.DISABLED }
                        onChange={ (input) => { this.appendFilter(input, 'DISABLED') } }
                    />
                    <label htmlFor="disabled">
                        <span></span>
                        Только отключенные
                    </label>

                    <input
                        type="checkbox"
                        id="archive"
                        name="archive"
                        value="1"
                        checked={ this.state.FILTER.ARCHIVE }
                        onChange={ (input) => { this.appendFilter(input, 'ARCHIVE') } }
                    />
                    <label htmlFor="archive">
                        <span></span>
                        Только архивные
                    </label>
                    <div className="printerInput">
                        <input
                            placeholder="IP Принтера печати этикеток"
                            value={ this.props.PRINTER_IP ? this.props.PRINTER_IP : '' }
                            label="IP Принтера/Весов"
                            type="text"
                            onChange={ (e) => this.props.setPrinterIp(e.target.value) }
                            margin="0px"
                        />
                    </div>
                </div>
            );
        }
    }

    renderGroupSelect = () => {
        if ((this.state.LOADED) && (this.state.GROUPS)) {
            let OPTIONS = [];
            OPTIONS.push(
                <option key="default" value="0">Выбрать категорию</option>
            );
            for (let i = 0; i < this.state.GROUPS.length; i++) {
                let OPT = this.state.GROUPS[i];
                OPTIONS.push(
                    <option key={ i } value={ OPT.id }>{ OPT.title }</option>
                );
            }

            return (
                <div className="filter_inputs_holder">
                    <div className="filter_element">
                        <select
                            value={ this.state.FILTER.GROUP }
                            onChange={ (text) => this.appendFilter(text, 'GROUP') }
                        >
                            { OPTIONS }
                        </select>
                        <img className="select_icon" src="/system_images/angle.png" />
                    </div>
                </div>
            );
        }
    }

    render() {
        if (!this.state.USER) {
            return <Redirect to="/" />
        }

        return (
            <div className="main_content">
                <Helmet>
                    <title>QR на товары</title>
                </Helmet>
                { this.renderFiter() }
                { this.renderProducts() }
                { this.state.PRINT_PRODUCT ? <ProductionInterface user={ this.props.USER } printerIP={ this.props.PRINTER_IP } onClose={ () => this.setState({ PRINT_PRODUCT: false }) } product={ this.state.PRINT_PRODUCT } /> : null }
            </div>
        );
    }
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(Qr))
